/**
 * Module dependencies.
 */

import { Tour } from 'src/types/tour';

/**
 * Export `tours`
 */

export const tours: Tour[] = [
  {
    coordinates: {
      lat: 38.52009409649944,
      lng: -8.894003893867835
    },
    slug: 'setubal'
  },
  {
    bearing: 80,
    coordinates: {
      lat: 39.605974987755026,
      lng: -8.412754423327733
    },
    slug: 'tomar-constancia'
  },
  {
    coordinates: {
      lat: 40.53186425360611,
      lng: -7.269050869178165
    },
    slug: 'guarda-pinhel-cidadelhe'
  },
  {
    coordinates: {
      lat: 41.8028159,
      lng: -6.7677626
    },
    slug: 'braganca'
  },
  {
    bearing: 60,
    coordinates: {
      lat: 40.203501,
      lng: -8.419946
    },
    slug: 'coimbra'
  },
  {
    coordinates: {
      lat: 38.56956258748392,
      lng: -7.91068413827162
    },
    slug: 'evora-montemor-o-novo'
  },
  {
    coordinates: {
      lat: 38.0148865,
      lng: -7.8632577
    },
    slug: 'beja'
  },
  {
    coordinates: {
      lat: 37.4699206,
      lng: -7.4731015
    },
    slug: 'alcoutim'
  },
  {
    bearing: -30,
    coordinates: {
      lat: 37.085013,
      lng: -8.671348
    },
    slug: 'lagos'
  },
  {
    coordinates: {
      lat: 38.9377,
      lng: -9.33223
    },
    slug: 'mafra'
  },
  {
    bearing: 50,
    coordinates: {
      lat: 41.44443,
      lng: -8.29619
    },
    slug: 'guimaraes'
  },
  {
    coordinates: {
      lat: 41.2959,
      lng: -7.74635
    },
    slug: 'vila-real'
  },
  {
    coordinates: {
      lat: 38.755912,
      lng: -9.311142
    },
    slug: 'lisboa-sintra-cascais'
  }
];
